import { Component } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { delay, map, of } from 'rxjs';
import { SearchSelectComponent } from '@flowkit/search-select';
import { ErrorComponent } from '@flowkit/error';

@Component({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    SearchSelectComponent,
    ErrorComponent,
  ],
  selector: 'app-ui-search-select',
  template: `
    <div>
      <h1 class="heading-title">Search select</h1>
      <div class="flex flex-col gap-10">
        <ng-template #selectedTemplateRef let-item="item">
          {{ item }}
        </ng-template>
        <ng-template #optionTemplateRef let-option="option">
          {{ option }}
        </ng-template>
        <flk-search-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [fetch]="fetchStringOptions"
          [formControl]="control1"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
        <flk-search-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [fetch]="fetchStringOptions"
          [formControl]="control2"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
        <flk-search-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [fetch]="fetchStringOptions"
          [formControl]="control3"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96">
          <flk-error>Field is required</flk-error>
        </flk-search-select>
        <flk-search-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [fetch]="fetchLongStringOptions"
          [formControl]="control4"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
      </div>
    </div>
  `,
})
export class UISearchSelectComponent {
  placeholder = 'Select your name';
  label = 'Name';

  stringOptions = ['Marcelo', 'Jens', 'Alex', 'Tim'];
  longStringOptions = [
    'Marcelo',
    'Jens',
    'Alex',
    'Tim',
    'Morten',
    'Ben',
    'Tom',
    'Leo',
  ];

  control1 = new FormControl('Marcelo');
  control2 = new FormControl({ value: '', disabled: true });
  control3 = new FormControl('', [Validators.required]);
  control4 = new FormControl('');

  fetchBy = (data: string[]) => {
    return (query: string | null) => {
      return of(data).pipe(
        delay(500),
        map(data => {
          return data.filter(it => it.includes(query ?? ''));
        })
      );
    };
  };

  fetchStringOptions = this.fetchBy(this.stringOptions);
  fetchLongStringOptions = this.fetchBy(this.longStringOptions);
}
